import Vue from 'vue'
import Configuration from '@/agilis/util/Configuration'

export default {
  namespaced: true,

  state: {
    currentTours: {},
    userTours: []
  },

  getters: {
    currentTour (state) {
      let currentTour = ''
      for (const tour in state.currentTours) {
        currentTour = tour
      }
      return currentTour
    },
    userTours (state) {
      return state.userTours
    },
    tours (state, getters, rootState, rootGetters) {
      let tours = {}
      if (rootGetters['configurationStore/configurationLoadingCompleted']) {
        const tourConfig = rootGetters['configurationStore/tour'] || {}
        tours = Configuration.tour.getTourList(tourConfig, tours)
      }
      return tours
    },
    tour (state, getters) {
      const currentTour = getters.currentTour
      const tours = getters.tours
      return tours[currentTour]
    },
    tourRootId (state, getters, rootState, rootGetters) {
      const tourConfig = rootGetters['configurationStore/tour'] || {}
      let tourRootId = 'root'
      for (const rootId in tourConfig) {
        tourRootId = rootId
      }
      return tourRootId
    }
  },

  mutations: {
    setTour: (state, name) => {
      Vue.set(state.currentTours, name, 0)
    },
    deleteTour: (state, name) => {
      Vue.delete(state.currentTours, name)
    },
    updateTour: (state, { name, step }) => {
      Vue.set(state.currentTours, name, step)
    },
    setUserTour: (state, tours) => {
      state.userTours = tours
    },
    deleteUserTour: (state, tourId) => {
      const index = state.userTours.indexOf(state.userTours.find(tour => tour.id === tourId))
      if (index > -1) {
        state.userTours.splice(index, 1)
      }
    }
  }
}
